import { Controller } from '@hotwired/stimulus'

// Controls visibility of Program Manager-dependent fields (e.g., scheduling URL)
export default class extends Controller {
  static targets = ['roleSelect', 'schedulingField']
  static values = {
    programManager: String,
  }

  connect() {
    this.update()
  }

  update() {
    if (!this.hasRoleSelectTarget || !this.hasSchedulingFieldTarget) return

    const selectedValues = this.roleSelectValues()
    const hasProgramManager = selectedValues.includes(this.programManagerValue)

    this.schedulingFieldTarget.classList.toggle('hidden', !hasProgramManager)
  }

  roleSelectValues() {
    const select = this.roleSelectTarget

    if (select.values) {
      return Array.from(select.values)
    }

    if (select.selectedOptions) {
      return Array.from(select.selectedOptions).map((option) => option.value)
    }

    return []
  }
}
